/** @format */
import apm from '../../helpers/elastic-apm-rum';
import { flattenObject } from '../../helpers/object';

type Labels = Record<string, any>;

const formatLabels = (labels: Labels) => {
    return flattenObject(labels, (val: any) => `${val}`);
};

const addLabels = (labels: Labels) =>
    apm ? apm?.addLabels(formatLabels(labels)) : console.log(labels);

const logError = (error: Error | string) =>
    apm ? apm?.captureError(error) : console.error(error);

export default {
    error: logError,
    addLabels,
};
